import { useEffect } from "react";

/**
 * A wrapper around useEffect that only runs on mount.
 * Avoids the need to disabled eslint rule react-hooks/exhaustive-deps.
 *
 * If you need to run a cleanup function on unmount, pass it in as the second argument.
 * If you ONLY need unmount logic, please try useOnUnmount instead.
 */
export const useOnMount = (
  callback: () => void,
  onUnmountCleanupCallback?: () => void,
) => {
  useEffect(
    () => {
      callback();

      return () => {
        onUnmountCleanupCallback?.();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
